import BaseModel from '@core/model';

export class BusinessStage extends BaseModel {
    static name = 'BusinessStage';
    static entity = 'businessStages';

    static fields() {
        return {
            id: this.attr(null),
            name: this.string('')
        };
    }
}

export default BusinessStage;
